<template>
  <div class="social-links"
       :class="component_classes">
    <a
      v-for="(link, index) in links"
      :aria-label="`Company page on social platform ${link.platform}`"
      :href="link.href"
      rel="noreferrer noindex nofollow"
      target="_blank"
      :key="`social-links-${index}`">
      <component
        :is="link.component"
        :size="size"
        />
    </a>
  </div>
</template>

<script>
import InstagramIcon from "../../icons/InstagramIcon.vue";
import FacebookIcon from "../../icons/FacebookIcon.vue";
import LinkedinIcon from "../../icons/LinkedinIcon.vue";
import YouTubeIcon from "../../icons/YouTubeIcon.vue";

export default {
  name: "SocialLinks",
  components: {
    YouTubeIcon,
    LinkedinIcon,
    FacebookIcon,
    InstagramIcon
  },
  props: {
    light: {
      type: Boolean,
      default: false
    },
    no_padding: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 24
    }
  },
  computed: {
    component_classes() {
      return {
        light: this.light,
        no_padding: this.no_padding
      };
    },
    links() {
      return [
        {
          platform: 'Facebook',
          component: 'facebook-icon',
          href: 'https://www.facebook.com/veoworldwideservices',
        },
        // {
        //   platform: 'Instagram',
        //   component: 'instagram-icon',
        //   href: 'https://www.instagram.com/veoworldwideservices/',
        // },
        {
          platform: 'LinkedIn',
          component: 'linkedin-icon',
          href: 'https://www.linkedin.com/company/veo-worldwide-services/mycompany/verification/',
        },
        {
          platform: 'You tube',
          component: 'you-tube-icon',
          href: 'https://www.youtube.com/@veoworldwideservices10',
        }
      ]
    }
  }
}
</script>
